module.exports = __webpack_public_path__ + "img/title-zh.f84ff5c1.png";